module.exports = __webpack_public_path__ + "img/sShkBoomX2_350x350.b5df7663.jpg";